export default class AppMapCluster {
    constructor () {
        let self = this;
        $('[data-toggle=clustermap]').each(function () {
            self.init($(this));
        });
    }

    init ($map) {
        let map = new GMaps({
            div: '#' + $map.attr('id'),
            lat: 53.551085,
            lng: 9.993682,
            styles: [
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [{visibility: 'off'}],
                },
            ],
        });

        let locations = $map.data('locations');
        let bounds = [];
        let markers = [];
        for (let location of locations) {
            let latlng = new google.maps.LatLng(location.lat, location.lng);
            bounds.push(latlng);
            markers.push(map.addMarker(location));
        }
        map.fitLatLngBounds(bounds);
        new MarkerClusterer(map.map, markers, {
            imagePath: '/img/markerclusterer/m',
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mapCluster.js